import { render } from "./PersonCardDNA.vue?vue&type=template&id=8e7ddbf4&scoped=true"
import script from "./PersonCardDNA.vue?vue&type=script&lang=js"
export * from "./PersonCardDNA.vue?vue&type=script&lang=js"

import "./PersonCardDNA.vue?vue&type=style&index=0&id=8e7ddbf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7ddbf4"]])

export default __exports__